import React from "react";
import { useTranslation } from "react-i18next";

function AIActivityStream({ logs, cardStyle }) {
  const { t } = useTranslation();

  return (

    <div style={cardStyle}>

      <h3>{t("commandCenter.activityStream.title")}</h3>

      <div
        style={{
          maxHeight: "250px",
          overflowY: "auto"
        }}
      >

        {logs.map((log, index) => (

          <div
            key={index}
            style={{
              borderBottom: "1px solid #1e293b",
              padding: "10px 0"
            }}
          >

            {typeof log === "string" ? (

              <div
                style={{
                  fontWeight: "bold",
                  color: "#38bdf8"
                }}
              >
                {log}
              </div>

            ) : (

              <>
                <div
                  style={{
                    fontWeight: "bold",
                    color: "#38bdf8"
                  }}
                >
                  [{log.time}] {log.agent === "telemetryEngine" ? t("commandCenter.telemetryEngine") : log.agent}
                </div>

                <div>
                  {t(`commandCenter.telemetryExplanations.${log.message}`, log.message)}
                </div>
              </>

            )}

          </div>

        ))}

      </div>

    </div>

  );

}

export default AIActivityStream;